import {useMemo, useState, useEffect} from 'react';

export const PAGE_SIZE = 20;

/**
 * Client-side pagination helper for KB entity detail tabs.
 *
 * @param {Array}  items     - Full array to paginate.
 * @param {number} [pageSize=PAGE_SIZE] - Items per page.
 * @returns {{ page, setPage, pageItems, totalPages, hasPagination }}
 */
export function usePagination(items, pageSize = PAGE_SIZE) {
    const [page, setPage] = useState(1);

    // Reset to page 1 whenever the source array changes (e.g. tab switch or refetch).
    useEffect(() => {
        setPage(1);
    }, [items]);

    const totalPages = useMemo(
        () => Math.max(1, Math.ceil((items?.length || 0) / pageSize)),
        [items, pageSize],
    );

    const pageItems = useMemo(() => {
        if (!items?.length) return [];
        const start = (page - 1) * pageSize;
        return items.slice(start, start + pageSize);
    }, [items, page, pageSize]);

    return {
        page,
        setPage,
        pageItems,
        totalPages,
        hasPagination: (items?.length || 0) > pageSize,
    };
}
